import React, { FC, ReactNode } from "react";
import { Button, Tabs } from "antd";
import { BookOutlined } from "@ant-design/icons";
import clsx from "clsx";
import styles from "../library.css";
import { Icons } from "../../vpd-icons/icons";

const {
  ["container"]: containerClassName,
  ["library-closed"]: libraryClosedClassName,
  ["library-opened"]: libraryOpenedClassName,
  ["library-closed-header"]: libraryClosedHeaderClassName,
} = styles as any;

export type LibraryProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  tabs: ReactNode;
  onChange?: (key: string) => void;
};

export const ScopeLibrary: FC<LibraryProps> = ({ open, setOpen, tabs, onChange }) => {
  return (
    <>
      <div
        className={clsx(containerClassName, open ? libraryClosedClassName : libraryOpenedClassName)}
      >
        <header>
          <h1>
            <BookOutlined onClick={() => setOpen(true)} />
          </h1>
        </header>
      </div>
      <div
        className={clsx(containerClassName, open ? libraryOpenedClassName : libraryClosedClassName)}
      >
        <header>
          <h1>
            <div className={libraryClosedHeaderClassName}>
              <BookOutlined />
              <Button icon={Icons.Close} onClick={() => setOpen(false)} />
            </div>
          </h1>
        </header>
        <Tabs onChange={(key) => onChange && onChange(key)} type="card">
          {tabs}
        </Tabs>
      </div>
    </>
  );
};
